import styled from 'styled-components';

export type AlertSeverity = 'success' | 'info' | 'warning' | 'error';

const getBackgroundColor = (severity: AlertSeverity, colors: Record<string, string>): string => {
  switch (severity) {
    case 'success':
      return colors.green50;
    case 'info':
      return colors.blue50;
    case 'warning':
      return colors.secondary50;
    case 'error':
      return colors.red50;
    default:
      return colors.blue50;
  }
};

const getAccentColor = (severity: AlertSeverity, colors: Record<string, string>): string => {
  switch (severity) {
    case 'success':
      return colors.green500;
    case 'info':
      return colors.blue500;
    case 'warning':
      return colors.secondary500;
    case 'error':
      return colors.red500;
    default:
      return colors.blue500;
  }
};

export const AlertWrapper = styled.div<{ $severity: AlertSeverity }>`
  display: flex;
  align-items: stretch;
  gap: 0;
  min-height: 48px;
  background-color: ${({ theme, $severity }) => getBackgroundColor($severity, theme.colors)};
  border-radius: 8px;
  overflow: hidden;
`;

export const AlertAccentBar = styled.div<{ $severity: AlertSeverity }>`
  width: 4px;
  flex-shrink: 0;
  background-color: ${({ theme, $severity }) => getAccentColor($severity, theme.colors)};
`;

export const AlertContent = styled.div<{ $severity: AlertSeverity }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.sizes['2xs']};
  padding: ${({ theme }) => theme.sizes['2xs']} ${({ theme }) => theme.sizes.sm};
  flex: 1;

  svg {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin-top: 2px;
    color: ${({ theme, $severity }) => getAccentColor($severity, theme.colors)};
  }
`;

export const AlertTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AlertTitle = styled.span<{ $severity: AlertSeverity }>`
  font-size: ${({ theme }) => theme.sizes['2xs']};
  font-weight: 700;
  line-height: 1.4;
  color: ${({ theme, $severity }) => getAccentColor($severity, theme.colors)};
`;

export const AlertMessage = styled.span`
  font-size: ${({ theme }) => theme.sizes['2xs']};
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.neutral800};
`;
